.ux-slider {
  display: block;
  outline: none !important;
  position: relative;

  &--slides-auto-height {
    .ux-slider-slide {
      height: auto !important;
    }
  }

  &--slides-overflow-visible {
    max-width: 100%;
    overflow-x: hidden;

    .ux-slider-slide {
      overflow: visible;
    }

    .ux-slider-container {
      overflow: visible;
    }
  }

  &__content-container {
    position: relative;
  }

  &__inner-container {
    float: none !important;
  }

  &__faded-side {
    cursor: pointer;
    height: calc(110%);
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
    transition: opacity 0.5s ease;
    width: 80px;
    z-index: $z-index-slider-faded-side;

    &--left {
      background: linear-gradient(to left, rgb(255 255 255 / 2%) 0, #fff 100%);
      left: 0;
    }

    &--right {
      background: linear-gradient(to right, rgb(255 255 255 / 2%) 0, #fff 100%);
      right: 0;
    }

    @media only screen and (width <= 568px) {
      display: none;
    }
  }

  &[direction="vertical"] {
    .ux-slider-container,
    .ux-slider__content-container,
    .ux-slider__inner-container {
      height: 100%;
      max-height: 100%;
    }
  }
}

.ux-slider .ux-slider-button {
  background: $color-white;
  border: 0;
  box-shadow: 0 7px 22px transparentize($color-black, 0.92);
  height: 60px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  z-index: $z-index-slider-button;

  ux-icon {
    font-size: 35px;
    height: 35px;
    transition: all 0.3s;
    width: 30px;
  }

  &:hover {
    background: $color-white !important;

    ux-icon {
      color: $color-green;
    }
  }
}

.ux-slider--faded-sides {
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;

  .ux-slider-container {
    overflow: visible;
  }
}

.ux-slider--cards {
  .ux-slider__content-container {
    overflow: hidden;
    padding: 0 20% 25px 30px;

    @media (min-width: 568px) {
      padding: 0 calc(20% + 45px) 25px 85px;
    }
  }

  .ux-slider-slide:not(.ux-slider-slide-next ~ .ux-slider-slide) {
    opacity: 0;
  }

  .ux-slider-slide {
    background-color: $color-white;
  }

  .ux-slider-slide-next,
  .ux-slider-slide-active {
    opacity: 1 !important;
  }

  .ux-slider-slide-next ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide ~ .ux-slider-slide {
    opacity: 0 !important;
  }

  .ux-slider-slide-prev {
    opacity: 0.3 !important;
    transition: all 0.3s !important;
  }

  .ux-slider-button-prev {
    left: 20px;
  }

  .ux-slider-button-next {
    right: 20px;
  }
}

@import "./swiper";
